<template>
  <div>
    <PageHero />
    <BlogSection />
  </div>
</template>

<script>
import BlogSection from '@/components/Blogs/BlogSection.vue';
import PageHero from '@/components/Blogs/PageHero.vue';

export default {
  name: 'Blogs',
  components: {
    BlogSection,
    PageHero
  }
}
</script>

<style></style>